export const getHotSettings = (config) => {
	let settings = 
	{
		// data source
		data: config.sourceData && config.sourceData.length ? config.sourceData.slice(1) : [],
		colHeaders: (index) => {
			return (
				config.showContextMenu 
				? config.colHeaderRenderer(index)  
				: (config.sourceData && config.sourceData.length ? config.sourceData[0][index] : '')
			)
        },
		cells(row, col) {
			const cellProperties = {}
			cellProperties.renderer = config.rowRenderer
			return cellProperties
		},
		// column settings
		fixedColumnsLeft: 1,
		autoColumnSizeObject: false,
		stretchH: 'all',
		// row settings
		rowHeights: 40,
		filters: false,
		rowHeaders: false,
		viewportRowRenderingOffsetNumber: 80,
		// table settings
		readOnly: true,
		className: 'htMiddle handsontableCustomTheme',
		width: '100%',
		height: '100%',
		// licensing
		licenseKey: 'non-commercial-and-evaluation'
	};

	let columnReorderSettings = config.setColumnReorder ? 
	{
		manualColumnMove: true,
		beforeColumnMove: function(cols, target) {
			if(cols.includes(0) || target === 0){
		  		return false	// disable reordering of first column
		  	}
		},
	}
	: {};
	
	let contextMenuSettings = config.cellClick ?
	{
		contextMenu: config.contextMenuRenderer()
	}
	: {};

	Object.assign(settings, columnReorderSettings);
	Object.assign(settings, contextMenuSettings);

	return settings;
}
